// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3SRSn","rootNoMargin":"styles_rootNoMargin__EwUoU"};